<template>
  <div class="grid-document-header" ref="docHeader">
    <div class="document-logo">
      <div class="document-author-logo">
        <img src="../../assets/EWY_Logo_Claim_Salvia_RZ_RGB_Gradient.png" alt=" Eway Energy GmbH" />
      </div>
    </div>

    <div class="document-header-right">
      <div class="document-author-address">
        Eway Energy GmbH
        <br />Seewiesenstr. 12<br />73054 Eislingen
        <br />
        <br />Tel: +49 160 3889987<br />
        e.sciacca@eway-energy.com <br />www.eway-energy.com
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrintHeaderSSP',
  components: {},
  props: {
    offer: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.grid-document-header {
  margin: 1cm 1cm 0.5cm 1cm;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  gap: 1em;
}
.document-logo {
  text-align: left;
}
.document-logo img {
  width: 200px;
}
.document-header-right {
  text-align: right;
}

.document-author-address {
  //   font-weight: 700;
  line-height: 1.2em;
  text-align: right;
  font-size: 11px;
  color: $gray-600;
}
</style>
